export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      
      this.comments = this.Queries.SQL1 ? JSON.parse(JSON.stringify(this.Queries.SQL1)) : {}

      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.timeline   = json.timeline
      this.timeline.cutoff = this.Queries.SQL2[0].cutoff
      // Setting Host URL
      if (json && json.config && json.config.server) {
        this.set_HostURL(json.config.server)
      }

      // Columns of Header
      this.gmx_tableCoordinates('x', this.header.columns, 0)
      this.header.width = this.header.columns[this.header.columns.length-1].ex
      this.header.length = this.header.width + this.timeline.length

      // Modal - Columns of MenuItem
      this.gmx_tableCoordinates('x', this.menuItem.columns, 5)
      this.menuItem.width = this.menuItem.columns[this.menuItem.columns.length-1].ex

      this.set_Timeline()
    },

    gmx_getTimePeriod(date, cutoffDay, mth) {

      let weekday = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].findIndex(f=> f == cutoffDay)
      
      const year = date.getFullYear()
      const month = date.getMonth()

      const firstDay = new Date(year, month + (mth), 1) // 4개월 전 달의 첫 번째 날
      const lastDay = new Date(year, month + (mth+1), 0) // 4개월 전 달의 마지막 날

      
      const first = new Date(firstDay)
      first.setDate(first.getDate() + (weekday - first.getDay() + 7) % 7) // 첫 번째 특정 요일

      
      const last = new Date(lastDay)
      last.setDate(last.getDate() - (last.getDay() - weekday + 7) % 7) // 마지막 특정 요일

      const format = d =>
          `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

      return {
        first: format(first),
        last: format(last)
      }
      
    },

    set_HostURL(server) {
      switch (server) {
        case 'TRION':
          this.HOST = this.const_trion
          break
        case 'KASKIDA':
          this.HOST = this.const_kaskida
          break
        case 'GPL':
          this.HOST = this.const_gpl
          break
        case 'TRINITY':
          this.HOST = this.const_trinity
          break
        default:
          this.HOST = this.const_demo
          break
      }
    },


  }
}